var _ellipse, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataInterest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 29.9988,
    rx: 30,
    ry: 29.9988,
    fill: "#EFF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0018 30.3948C48.0018 28.9148 47.8792 27.8348 47.614 26.7148H30.3691V33.3947H40.4915C40.2875 35.0547 39.1855 37.5547 36.7364 39.2346L36.7021 39.4582L42.1546 43.5977L42.5324 43.6346C46.0017 40.4946 48.0018 35.8747 48.0018 30.3948Z",
    fill: "#6484F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3691 47.9945C35.3283 47.9945 39.4915 46.3944 42.5324 43.6346L36.7364 39.2345C35.1855 40.2945 33.1038 41.0345 30.3691 41.0345C25.512 41.0345 21.3896 37.8946 19.9201 33.5547L19.7047 33.5726L14.0351 37.8726L13.9609 38.0746C16.9813 43.9544 23.1854 47.9945 30.3691 47.9945Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9222 33.5539C19.5344 32.4339 19.31 31.2339 19.31 29.9939C19.31 28.7539 19.5344 27.5539 19.9018 26.434L19.8915 26.1954L14.1509 21.8264L13.963 21.914C12.7182 24.354 12.0039 27.094 12.0039 29.9939C12.0039 32.8939 12.7182 35.6338 13.963 38.0738L19.9222 33.5539Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3691 18.956C33.8181 18.956 36.1446 20.4159 37.4711 21.636L42.6548 16.676C39.4712 13.7761 35.3283 11.9961 30.3691 11.9961C23.1854 11.9961 16.9813 16.036 13.9609 21.9159L19.8997 26.4359C21.3896 22.096 25.512 18.956 30.3691 18.956Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataInterest);
export default __webpack_public_path__ + "static/media/data-interest.55d137fd909183d0bb6aeec44b191bad.svg";
export { ForwardRef as ReactComponent };